/**
 * Arche wrapper for Plugin Builder — handles sub-routing with layout variations:
 * - /:sessionId — full-screen plugin editor (no sidebar)
 * - / — wrapped in ArcheLayout (browsing/listing page)
 */

import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { PluginBuilderPage } from './PluginBuilderPage';
import { PluginSessionsListPage } from './PluginSessionsListPage';

export function PluginBuilderArchePage() {
  return (
    <Routes>
      {/* Plugin editor — full-screen, no sidebar */}
      <Route path="/:sessionId" element={<PluginBuilderPage />} />
      {/* Sessions list — gets ArcheLayout */}
      <Route
        path="/*"
        element={
          <ArcheLayout>
            <Routes>
              <Route path="/" element={<PluginSessionsListPage />} />
            </Routes>
          </ArcheLayout>
        }
      />
    </Routes>
  );
}
